export const QnAData = {
    "message": "File uploaded and processed successfully!",
    "qa_data": [
        {
            "question": "What is Lorem Ipsum?",
            "answer": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
            "page": 1,
        },
        {
            "question": "Where does it come from?",
            "answer": "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source.",
            "page": 1,
        },
        {
            "question": "Why do we use it?",
            "answer": "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.",
            "page": 1,
        },
        {
            "question": "Where can I get some?",
            "answer": "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.",
            "page": 1,
        },
        {
            "question": "Where can I get some?",
            "answer": "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.",
            "page": 1,
        },
        {
            "question": "Where can I get some?",
            "answer": "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.",
            "page": 1,
        },
        {
            "question": "Where can I get some?",
            "answer": "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.",
            "page": 1,
        },
        {
            "question": "Where can I get some?",
            "answer": "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.",
            "page": 1,
        },
        {
            "question": "Where can I get some?",
            "answer": "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.",
            "page": 1,
        },
        {
            "question": "Where can I get some?",
            "answer": "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.",
            "page": 1,
        },
    ]
}


// Qna-
// {
//     "message": "File processed successfully",
//     "qa_data": [{
//         "Question1": "example question",
//          “Answer1”: “example answer”,
//     }, 
// {
//         "Question2": "example question",
//          “Answer2”: “example answer”,
//     }, 
// ….
// ]
// }